module.exports = __webpack_public_path__ + "static/media/logo_full.aa6812d9.png";